import { default as config } from "common/config/config";
import type { PaginatedApproverDto } from "common/models/api/models/PaginatedApproverDto";
import { useQuery, UseQueryOptions, UseQueryResult } from "react-query";
import { Queries } from "ui/query/queries";
import { releaseStrategyApi } from "../api/releaseStrategyApi";

export interface UseFindAllApproversOptions {
    query?: string;
    page?: number;
    pageSize?: number;
}

export default function useFindApprovers(
    { query, pageSize = config.paginatedPageSizes.programs, page }: UseFindAllApproversOptions,
    options?: UseQueryOptions<PaginatedApproverDto, unknown, PaginatedApproverDto, (string | undefined | number)[]>,
): UseQueryResult<PaginatedApproverDto> {
    return useQuery(
        [Queries.RELEASE_STRATEGY_FIND_ALL, query, page, pageSize],
        async () => {
            const res = await releaseStrategyApi.findAllApprovers({ query, page, pageSize });
            return res.data;
        },
        { ...options },
    );
}
